// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/EmployeeFranchiseCombinationNestedInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import { registerContract } from './validate'

export interface EmployeeFranchiseCombinationNestedInput {
user_id: string
franchise_id: number
}

registerContract('EmployeeFranchiseCombinationNestedInput', {
  user_id:      { type: 'string',  required: true },
  franchise_id: { type: 'number',  required: true },
})
